import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsCountertopValue = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.countertop.value;

export const value = setCalculationModeAdminSettingsCountertopValue(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_COUNTERTOP_VALUE',
  { value: '', label: '' }
);
